import React from 'react'
import { Row, Col, Card, Nav } from 'react-bootstrap'
import { Organization } from 'interfaces/organization'
import {
  isOrganizationUpdated,
  isOrganizationPending,
} from 'utils/organization-utils'

interface StatusTabsProps {
  showUpdatedOnly: boolean
  setShowUpdatedOnly: (show: boolean) => void
  filteredCount: number
  allOrganizations: Organization[]
}

const StatusTabs: React.FC<StatusTabsProps> = ({
  showUpdatedOnly,
  setShowUpdatedOnly,
  filteredCount,
  allOrganizations,
}) => {
  const updatedCount = allOrganizations.filter(isOrganizationUpdated).length
  const pendingCount = allOrganizations.filter(isOrganizationPending).length

  return (
    <div className="d-flex align-items-center">
      <Nav
        variant="tabs"
        activeKey={showUpdatedOnly ? 'updated' : 'pending'}
        onSelect={(key) => {
          if (key === 'updated' || key === 'pending') {
            setShowUpdatedOnly(key === 'updated')
          }
        }}
      >
        <Nav.Item>
          <Nav.Link
            eventKey="pending"
            className={!showUpdatedOnly ? 'active' : ''}
            style={{
              color: 'white',
              border: '1px solid #dee2e6',
              borderBottom: !showUpdatedOnly
                ? '2px solid #007bff'
                : '1px solid #dee2e6',
              borderTopLeftRadius: '4px',
              borderTopRightRadius: '4px',
              marginRight: '2px',
            }}
          >
            Pending ({pendingCount})
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            eventKey="updated"
            className={showUpdatedOnly ? 'active' : ''}
            style={{
              color: 'white',
              border: '1px solid #dee2e6',
              borderBottom: showUpdatedOnly
                ? '2px solid #007bff'
                : '1px solid #dee2e6',
              borderTopLeftRadius: '4px',
              borderTopRightRadius: '4px',
              marginLeft: '2px',
            }}
          >
            Updated ({updatedCount})
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </div>
  )
}

export default StatusTabs
